import { createElement } from "react";
import React from "react";
import * as react from "react";
import { TaskMsg, useFeliz_UseElmish_React__React_useTaskDispatch_Static } from "../hooks/UseTaskDispatch.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { newGuid } from "../fable_modules/fable-library-js.4.24.0/Guid.js";
import { Facilities_UpdateFacility, Facilities_CreateFacility } from "../ServerTypes.fs.js";
import { update as update_1, create as create_2 } from "../Api/Facilities.fs.js";
import { Modal_ModalWithBreakdown } from "./Modal.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { singleton, cons, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

export function Create(createInputProps) {
    let xs_5, elms_1, elms;
    const close = createInputProps.close;
    const projectId = createInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState("");
    const name = patternInput_1[0];
    let create_1;
    const dependencies_1 = [name];
    create_1 = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, "Create"]));
                const create = new Facilities_CreateFacility(name);
                taskDispatch(new TaskMsg(2, [taskId]));
                return create_2(projectId, create).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_5 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))], react.createElement(react.Fragment, {}, ...xs_5)),
        submit: create_1,
        submitText: "Create",
        tasks: patternInput[0],
        title: "Create",
    });
}

export function Update(updateInputProps) {
    let xs_5, elms_1, elms;
    const close = updateInputProps.close;
    const facility = updateInputProps.facility;
    const projectId = updateInputProps.projectId;
    const patternInput = useFeliz_UseElmish_React__React_useTaskDispatch_Static();
    const taskDispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(facility.Name);
    const name = patternInput_1[0];
    let updates;
    const dependencies_1 = [name];
    updates = reactApi.useCallback(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            if (isNullOrWhiteSpace(name)) {
                return Promise.resolve();
            }
            else {
                const taskId = newGuid();
                taskDispatch(new TaskMsg(0, [taskId, `Update ${name}`]));
                const update = new Facilities_UpdateFacility(name);
                taskDispatch(new TaskMsg(2, [taskId]));
                return update_1(projectId, facility.Id, update).then((_arg) => {
                    const result = _arg;
                    if (result.tag === 1) {
                        taskDispatch(new TaskMsg(6, [taskId, result.fields[0]]));
                        return Promise.resolve();
                    }
                    else {
                        taskDispatch(new TaskMsg(3, [taskId, undefined]));
                        return Promise.resolve();
                    }
                });
            }
        }));
        void pr;
    }, dependencies_1);
    return createElement(Modal_ModalWithBreakdown, {
        close: close,
        content: (xs_5 = [(elms_1 = ofArray([createElement("label", {
            className: "label",
            children: "Name",
        }), (elms = singleton(createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", ofArray([["onChange", (ev) => {
            patternInput_1[1](ev.target.value);
        }], ["defaultValue", name]])))))), createElement("div", {
            className: "control",
            children: reactApi.Children.toArray(Array.from(elms)),
        }))]), createElement("div", {
            className: "field",
            children: reactApi.Children.toArray(Array.from(elms_1)),
        }))], react.createElement(react.Fragment, {}, ...xs_5)),
        submit: updates,
        submitText: "Update",
        tasks: patternInput[0],
        title: "Update",
    });
}

